import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import InternshipPolicy from "./pages/InternshipPolicy";
import Login from "./pages/Login";
import ApplicationPage from "./pages/ApplicationPage";
import InternshipManagementPage from "./pages/InternshipManagementPage";
import SubmissionSuccess from "./pages/SumissionSuccess";
import { UserProvider } from "../src/context/UserContext";
import AuthGuard from "./context/AuthGuard";
import JobApplicationPage from "./pages/JobPages/JobOpportunitiesPage";
import JobOpeningApplicationPage from "./pages/JobPages/JobApplicationPage";
import JobManagementPage from "./pages/JobPages/JobManagement";

const App = () => {
  return (
    <div className="min-h-screen bg-white">
      <UserProvider>
        <Router>
          <Routes>
            <Route path="/" element={<InternshipPolicy />} />
            <Route path="/application-page" element={<ApplicationPage />} />
            {/* //TODO: Remember to remove this */}
            <Route
              path="/job-application-page"
              element={<JobApplicationPage />}
            />
            <Route path="/apply-job" element={<JobOpeningApplicationPage />} />
            <Route path="/manage-jobs" element={<JobManagementPage />} />
            {/* //TODO: Remember to remove this */}
            <Route path="/login" element={<Login />} />
            <Route path="/submission-success" element={<SubmissionSuccess />} />
            <Route
              path="/hr-management"
              element={
                <AuthGuard>
                  <InternshipManagementPage />
                </AuthGuard>
              }
            />
          </Routes>
        </Router>
      </UserProvider>
    </div>
  );
};

export default App;
